import EditRubricTagModal from "./EditCategoryModal";

export default EditRubricTagModal;
